import React, { useState, useEffect } from 'react';
import './ImageWithBackground.css';
import MiniPreloader from '../MiniPreloader/MiniPreloader';

const defaultAspectRatios = {
    '16x10': 16 / 10,
    '10x16': 10 / 16,
    '1x1': 1 / 1,
};

const ImageWithBackground = ({ src, image_radius, className, image_format, metadata }) => {
    const [naturalAspectRatio, setNaturalAspectRatio] = useState(null);

    const metadataWidth = metadata?.extra?.size?.width;
    const metadataHeight = metadata?.extra?.size?.height;
    const metadataAspectRatio = metadataWidth && metadataHeight ? metadataWidth / metadataHeight : null;
    const defaultAspectRatio = defaultAspectRatios[image_format];
    const wrapperAspectRatio = defaultAspectRatio || metadataAspectRatio || naturalAspectRatio || null;

    // Preserve the frame ratio from tokens/metadata and never crop the image.
    const imageStyle = {
        width: '100%',
        height: '100%',
        maxHeight: '100%',
        maxWidth: '100%',
        objectFit: 'contain',
    };

    return (
        <div
            className={className}
            style={{
                backgroundColor: metadata?.extra?.pixels ? `rgb(${metadata.extra.pixels.r},${metadata.extra.pixels.g},${metadata.extra.pixels.b})` : 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: image_radius,
                aspectRatio: wrapperAspectRatio || undefined,
                width: '100%',
                height: 'auto',
                maxHeight: 'none',
                maxWidth: '100%',
            }}
        >
            <img
                className='image-with-background__img'
                style={imageStyle}
                src={src}
                alt=""
                onLoad={(e) => {
                    if (naturalAspectRatio) return;
                    const { naturalWidth, naturalHeight } = e.target;
                    if (naturalWidth && naturalHeight) {
                        setNaturalAspectRatio(naturalWidth / naturalHeight);
                    }
                }}
            />
        </div>
    );
};

export default ImageWithBackground;
